import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectNishitsunaisunWidth from 'components/site/select_nishitsunaisun_width'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectNishitsunaisunWidthStart: state.searchFormCondition.selectNishitsunaisunWidthStart,
  selectNishitsunaisunWidthFinish: state.searchFormCondition.selectNishitsunaisunWidthFinish,
})

const NishitsunaisunWidthContainer = connect(mapStateToProps, mapDispatchToProps)(SelectNishitsunaisunWidth)

export default NishitsunaisunWidthContainer
